import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden grain" style={{ background: "#0A0F2C" }}>
      <div className="glow-blob" style={{ width: 560, height: 560, top: -200, left: "30%", background: "radial-gradient(circle, rgba(29,78,216,0.45), transparent 65%)", animation: "drift1 14s ease-in-out infinite" }} />
      <div className="relative w-full max-w-md rounded-3xl glass-dark p-9" data-testid="admin-login-card">
        <div className="flex items-center gap-3">
          <img src="/logo-full.png" alt="TrustDesk — Skilled People. Real Progress." style={{ height: 36, width: "auto" }} />
        </div>
        <h1 className="mt-8 font-display font-extrabold text-white text-2xl">Sign in</h1>
        <p className="mt-1 text-sm text-slate-400">Manage your site, leads and content.</p>
        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
          <input
            className="admin-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="admin-login-email"
          />
          <input
            className="admin-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-login-password"
          />
          {error && <div className="text-sm text-red-400" data-testid="admin-login-error">{error}</div>}
          <button className="btn btn-primary w-full" disabled={busy} data-testid="admin-login-submit">
            {busy ? "Signing in..." : "Sign In"} <ArrowRight size={16} />
          </button>
        </form>
        <a href="/" className="block mt-6 text-xs text-slate-500 hover:text-slate-300 text-center transition-colors">← Back to website</a>
      </div>
    </div>
  );
}
